import { gql, TypedDocumentNode } from '@apollo/client'

import { GoogleAdManagerConnectionDTO } from './types'

export const GOOGLE_AD_MANAGER_CONNECTION_FRAGMENT: TypedDocumentNode<GoogleAdManagerConnectionDTO> = gql`
  fragment GoogleAdManagerConnectionFragment on GamConnectionOrder {
    errorMessage
    id
    status
    updatedAt
  }
`
